import type { ArgoEnvStatus } from './useArgoEnvStatuses';

export type ArgoStatusKind = 'ok' | 'warning' | 'error';

/**
 * Shared classification of an ArgoCD sync/health pair:
 * - `error` (red): a genuine health failure (Degraded or Missing).
 * - `ok` (green): fully reconciled — Synced and Healthy.
 * - `warning` (amber): drift or in-flight — OutOfSync, Progressing, Unknown.
 *
 * Out-of-sync (without a health failure) is amber, not red, so a red dot
 * always means something is actually broken rather than just behind. Consumers
 * map the kind to a foundation tone/color (StatusPill tone, catalog dots).
 */
export function argoStatusKind({
  sync,
  health,
}: ArgoEnvStatus): ArgoStatusKind {
  if (health === 'Degraded' || health === 'Missing') return 'error';
  if (sync === 'Synced' && health === 'Healthy') return 'ok';
  return 'warning';
}
